import React from 'react';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { signin } from '../../../modules/actions/user';
import Button from '../../components/form-elements/Button';
import { InternalLink } from '../../components/form-elements/Link';

const SigninSchema = Yup.object().shape({
    username: Yup.string().required('Pflichtfeld'),
    password: Yup.string().required('Pflichtfeld'),
});

function LoginForm({ standortUrl, signin }) {
    const handleSigninSubmit = async ({ username, password }, actions) => {
        await signin({ username, password });
        actions.setSubmitting(false);
    };

    return (
        <div className="uk-padding uk-padding-small aps-border aps-border-muted">
            <Formik initialValues={{ username: '', password: '' }} validationSchema={SigninSchema} onSubmit={handleSigninSubmit}>
                {({ errors, touched }) => (
                    <Form>
                        <div className="uk-margin">
                            <label htmlFor="username" className="uk-form-label">
                                E-Mail Adresse oder Benutzername *
                            </label>
                            <Field
                                id="username"
                                name="username"
                                className="uk-input"
                                type="text"
                                placeholder="E-Mail Adresse oder Benutzernamen eingeben"
                                required
                                autoComplete="email"
                                aria-required="true"
                            />
                            <ErrorMessage component="div" className="uk-text-danger" name="username" id="username-error" />
                        </div>
                        <div className="uk-margin">
                            <label htmlFor="password" className="uk-form-label">
                                Passwort *
                            </label>
                            <Field
                                id="password"
                                name="password"
                                className="uk-input"
                                type="password"
                                placeholder="Passwort eingeben"
                                required
                                autoComplete="current-password"
                                aria-required="true"
                            />
                            <ErrorMessage component="div" className="uk-text-danger" name="password" id="password-error" />
                        </div>
                        <div className="uk-margin">
                            <Button fullWidth type="submit">
                                Anmelden
                            </Button>
                        </div>
                        <div className="uk-margin">
                            <InternalLink to="/passwort-vergessen" className="uk-flex uk-flex-center">
                                <u>Passwort vergessen?</u>
                            </InternalLink>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

const mapDispatchToProps = { signin };

export default connect(null, mapDispatchToProps)(LoginForm);
